import { useSelector } from 'react-redux';

export default function useLoggedInUser() {
	const user = useSelector((state) => state.dashboard.player);
	return user;
}